<template>
  <ss-modal
    v-if="isCourtModalVisible"
    title="Title"
    intro="bounceIn"
    outro="bounceOut">
    <!-- HEADER -->
    <div slot="modal-header">
      {{ isEdit ? 'Edycja sądu' : 'Nowy sąd' }}
      <i class="close" @click="modalClose(false)"></i>
    </div>
    <!-- BODY -->
    <div slot="modal-body" >
      <ss-input
        label="Nazwa"
        placeholder="Nazwa sądu"
        name="name"
        v-model="court.name" />
    </div>
    <!-- FOOTER -->
    <div slot="modal-footer">
      <d-button
        @click.prevent="modalClose(false)"
        :class="{ disabled : actionInProgress }"
        theme="danger">
        Zamknij
      </d-button>
      <d-button
        @click.prevent="saveCourt"
        :class="{ isLoading: actionInProgress }"
        theme="success"
        class="ml-3">
        Zapisz
      </d-button>
    </div>
  </ss-modal>
</template>

<script>
import Vue from 'vue';
import SsModal from '@/components/common/SsModal';
import FormUtils from '@/utils/FormUtils.js';
import LarErrors from '@/helpers/Errors';

export default {
  name: 'CourtModal',
  components: {
    SsModal,
    LarErrors
  },
  props: {
    courtToEdit: {
      type: Object,
      default: () => {}
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isEdit () {
      return this.courtToEdit && this.courtToEdit.id;
    }
  },
  watch: {
    courtToEdit: {
      handler: function(to) {
        if (!to || !to.id) {
          this.court = {
            id: null,
            name: ''
          }
          return;
        }

        this.court = to;
      },
      deep: true
    },
    show(to) {
      this.isCourtModalVisible = to;
    },
  },
  data () {
    return {
      court: {
        id: null,
        name: ''
      },
      isCourtModalVisible: false,
      actionInProgress: false,
      lar_errors: LarErrors,
    }
  },
  mounted () {
    this.isCourtModalVisible = this.show;
    if (this.courtToEdit && this.courtToEdit.id) {
      this.court = this.courtToEdit;
    }
  },
  methods: {
    saveCourt () {
      Vue.set(this, 'actionInProgress', true);

      let endpointUrl = this.court.id ? ('api/courts/update/' + this.court.id) : 'api/courts/store';
      FormUtils.submit(this, {
        endpoint: endpointUrl,
        formData: this.court,
        successTitle: 'Sąd został zapisany.',
        successText: '',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Zapisywanie sądu nie powiodło się. Spróbuj ponownie.',
        successAction: (response) => {
          this.courtReset();
          this.modalClose(true, response.data);
        },
        failAction: (error) => {
          console.log(error);
          LarErrors.record(error.data.errors)
        }
      });

      Vue.set(this, 'actionInProgress', false);
    },
    courtReset () {
      this.court = {
        id: null,
        name: ''
      }
    },
    modalClose (shoudlReload, newCourt = null) {
      this.$bus.$emit('court-modal-hide', shoudlReload, newCourt);
    }
  }
}
</script>
